import { render, staticRenderFns } from "./SubForm.vue?vue&type=template&id=5c9ca348&scoped=true&"
import script from "./SubForm.vue?vue&type=script&lang=js&"
export * from "./SubForm.vue?vue&type=script&lang=js&"
import style0 from "./Shared/Styles/Form.css?vue&type=style&index=0&id=5c9ca348&scoped=true&lang=css&"
import style1 from "./SubForm.vue?vue&type=style&index=1&id=5c9ca348&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9ca348",
  null
  
)

export default component.exports